const ComponentTabs = class extends HTMLElement {
    tabButton = this.querySelectorAll('.tab-button');
    tabContent = this.querySelectorAll('.tab-content');

    connectedCallback() {
        this.tabButton.forEach(button => {
            button.addEventListener('click', (e) => {
                this.changeTab(e, button)
            });
        })
    }

    changeTab(e, item) {
        const dataNewTab = item.dataset.tab;
        const newTab = this.querySelector(`.tab-content[data-tab="${dataNewTab}"]`);
        this.tabButton.forEach(button => {
            button.classList.remove('active');
        })
        this.tabContent.forEach(tab => {
            tab.classList.remove('active');
        })
        newTab.classList.add('active');
        item.classList.add('active');
    }
};

if (!customElements.get('component-tabs')) {
    window.customElements.define('component-tabs', ComponentTabs);
}
